
var wfT = window.wfI18n || function(message, values = []) { return message.replace(/\{(\d+)\}/g, (_, i) => String(values[Number(i)] ?? '')); };
var wfH = function(message, values = []) { return wfT(message, values).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c])); };
(() => {
  // These are app actions, not navigation links. Keep the app's nodes and click
  // handlers intact while making its asynchronously mounted Back action usable
  // from the keyboard. Review modals can mount outside MainContent.
  const backSelector = 'a.jdgm-write-review-modal__btn--back:not([href])';
  const linkSelector = '.jm-product-variant-card__product-link[aria-label]';
  const selector = `${backSelector}, ${linkSelector}`;
  const repair = element => {
    if (element.matches(backSelector)) {
      element.setAttribute('role', 'button');
      if (!element.hasAttribute('tabindex')) element.tabIndex = 0;
    } else if (element.matches(linkSelector)) {
      const label = element.getAttribute('aria-label');
      if (label.includes('&amp;')) element.setAttribute('aria-label', label.replaceAll('&amp;', '&'));
    }
  };
  const scan = root => {
    if (root.nodeType !== 1) return;
    if (root.matches(selector)) repair(root);
    root.querySelectorAll(selector).forEach(repair);
  };
  scan(document.body);
  new MutationObserver(records => {
    for (const record of records) {
      if (record.type === 'attributes') repair(record.target);
      else record.addedNodes.forEach(scan);
    }
  }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-label'] });
  document.addEventListener('keydown', event => {
    if (event.defaultPrevented || event.repeat || !['Enter', ' '].includes(event.key)) return;
    const button = event.target.closest?.(backSelector);
    if (!button) return;
    event.preventDefault();
    button.click();
  });
})();
(() => {
  const root = document.getElementById('MainContent');
  if (!root) return;

  // Judge.me's single-star summary reports the number of drawn icons as its
  // scale. Correct only that summary; individual review ratings stay intact.
  const selector = '.jm-average-rating-display .jm-star-rating[role="img"][aria-label]';

  const correctSummary = () => {
    for (const rating of root.querySelectorAll(selector)) {
      const label = rating.getAttribute('aria-label');
      const match = /^(\d+(?:\.\d+)?) out of 1 stars?$/.exec(label || '');
      if (!match) continue;

      const value = Number(match[1]);
      if (!Number.isFinite(value) || value < 0 || value > 5) continue;

      const display = rating.nextElementSibling?.textContent?.trim() || '';
      const displayValue = Number(display);
      const matchesDisplay = /^\d+(?:\.\d+)?$/.test(display)
        && displayValue >= 0 && displayValue <= 5
        && Math.abs(displayValue - value) <= 0.051;
      const score = matchesDisplay ? display : match[1];
      rating.setAttribute('aria-label', wfT("{0} out of 5 stars", [score]));
    }
  };

  correctSummary();

  // The app mounts and replaces its summary after the initial page render.
  // Writes are idempotent: Correct five-star labels are never written again.
  const observer = new MutationObserver(correctSummary);
  observer.observe(root, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['aria-label'],
    characterData: true,
  });
})();
